import React, {useEffect, useRef, useState} from 'react';
import {withTranslation} from "react-i18next";
import {logo} from "../helpers/img";
import ThemeSwitcher from "../components/Switcher/ThemeSwitcher";
import {Link} from "react-router-dom";
import {LINK_ABOUT, LINK_CONTACT, LINK_HOME, LINK_PORTFOLIO} from "../routes/type";
import {ActiveMenu, getData} from "../helpers/utils";
import LanguageSwitcher from '../components/Switcher/LanguageSwitcher';

const Header = ({t,pageName,text, isScrolled}) => {
    const dropdownsRef = useRef([]);

    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const result = await getData();
            setData(result);
        };

        fetchData();
    }, []);


    useEffect(() => {
        const handleMouseEnter = (e) => {
            const menu = e.target.querySelector(".dropdown-menu");
            if (menu) {
                menu.style.display = "block";
            }
        };

        const handleMouseLeave = (e) => {
            const menu = e.target.querySelector(".dropdown-menu");
            if (menu) {
                menu.style.display = "none";
            }
        };

        // Only apply for large screens
        if (window.matchMedia("(min-width: 992px)").matches) {
            dropdownsRef.current = document.querySelectorAll(".dropdown-hover .dropdown");

            dropdownsRef.current.forEach((dropdown) => {
                dropdown.addEventListener("mouseenter", handleMouseEnter);
                dropdown.addEventListener("mouseleave", handleMouseLeave);
            });

            // Cleanup on unmount
            return () => {
                dropdownsRef.current.forEach((dropdown) => {
                    dropdown.removeEventListener("mouseenter", handleMouseEnter);
                    dropdown.removeEventListener("mouseleave", handleMouseLeave);
                });
            };
        }
    }, []);


    const midIndex = Math.ceil(data?.services?.length / 2);
    const leftItems = data?.services?.slice(0, midIndex);
    const rightItems = data?.services?.slice(midIndex);




    return (
        <>
            <header className={`header-sticky header-absolute  ${isScrolled ? "header-sticky-on" : ""}`} data-bs-theme="dark">
                <nav className="navbar navbar-expand-xl px-lg-5">
                    <div className="container-fluid">
                        <Link className="navbar-brand me-5"  to={LINK_HOME}>
                            <img className="light-mode-item navbar-brand-item" src={logo} alt="logo"/>
                            <img className="dark-mode-item navbar-brand-item" src={logo} alt="logo"/>
                        </Link>

                        <div className="navbar-collapse collapse" id="navbarCollapse">
                            <ul className="navbar-nav navbar-nav-scroll dropdown-hover">
                                <li className="nav-item"><Link className={ActiveMenu(LINK_HOME)+" nav-link"} to={LINK_HOME}>{t('menu.home')}</Link></li>

                                <li className="nav-item"><Link className={ActiveMenu(LINK_ABOUT)+" nav-link"} to={LINK_ABOUT}>{t('menu.about')}</Link></li>

                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" data-bs-auto-close="outside"
                                       data-bs-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false">{t('menu.services')}</a>
                                    <div className="dropdown-menu dropdown-menu-size-lg p-3">
                                        <div className="row pt-2">
                                            <div className="col-sm-6">
                                                <ul className="list-unstyled">
                                                    {leftItems?.map((item, index) => (
                                                        <li key={index}>
                                                            <Link className="dropdown-item"
                                                               to={"/service/"+item.key}>{item.name}</Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="col-sm-6">
                                                <ul className="list-unstyled">
                                                    {rightItems?.map((item, index) => (
                                                        <li key={index}>
                                                            <Link className="dropdown-item"
                                                               to={"/service/"+item.key}>{item.name}</Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="col-12">
                                                <hr className="mt-2"/>
                                                <div
                                                    className="d-sm-flex justify-content-between align-items-center px-2">
                                                    <div className="me-3 mb-2 mb-sm-0">
                                                        <h6 className="mb-2 mb-sm-0">{t('menu.ready_start')}</h6>
                                                        <small className="mb-0">Take your documents to the next level
                                                            with Mizzle</small>
                                                    </div>
                                                    <Link to={LINK_CONTACT} className="btn btn-sm btn-primary">{t('menu.get_in_touch')}</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>


                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown"
                                       aria-haspopup="true" aria-expanded="false">Portfolio</a>
                                    <div className="dropdown-menu dropdown-menu-center dropdown-menu-size-lg p-3">
                                        <div className="row g-xl-3">
                                        <div className="col-xl-7 d-none d-xl-block">
                                                <div className="d-flex gap-4">

                                                    <div className="card bg-transparent">

                                                        <img src={data?.portfolio[0].picture}
                                                             className="card-img" alt=""/>

                                                        <div className="card-body px-0 text-start pb-0">
                                                            <h6><Link to={"/portfolio/"+data?.portfolio[0].slug}>{data?.portfolio[0].name}</Link></h6>
                                                            <p className="mb-2 small">{data?.portfolio[0].category} , {data?.portfolio[0].customer} </p>
                                                            <Link className="icon-link icon-link-hover stretched-link mb-0" to={"/portfolio/"+data?.portfolio[0].slug}>
                                                                {t('read_more')} <i className="bi bi-arrow-right"></i>
                                                            </Link>
                                                        </div>
                                                    </div>

                                                    <div className="vr ms-2"></div>
                                                </div>
                                            </div>


                                            <div className="col-xl-5">
                                                <ul className="list-unstyled">
                                                    <li className="dropdown-header h6"><Link to={LINK_PORTFOLIO}>Portfolio</Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>


                                <li className="nav-item"><Link className={ActiveMenu(LINK_CONTACT)+" nav-link"} to={LINK_CONTACT}>{t('menu.contact')}</Link>
                                </li>
                            </ul>
                        </div>


                        <ul className="nav align-items-center dropdown-hover ms-sm-2">
                            <li className="nav-item dropdown dropdown-animation">
                                <button className="btn btn-link mb-0 px-2 lh-1" id="bd-theme"
                                        type="button"
                                        aria-expanded="false"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                         className="bi bi-circle-half theme-icon-active fill-mode fa-fw"
                                         viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>
                                        <use href="#"></use>
                                    </svg>
                                </button>

                                <ThemeSwitcher />
                            </li>

                            <li className="nav-item position-relative ms-2 ms-sm-3 d-none d-sm-block">
                                <LanguageSwitcher />
                            </li>


                            <li className="nav-item">
                                <button className="navbar-toggler ms-3 p-2" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#navbarCollapse" aria-controls="navbarCollapse"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-animation">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                        </span>
                                </button>
                            </li>
                        </ul>

                    </div>
                </nav>
            </header>

        </>
    )
}

export default withTranslation()(Header)